export interface IndexBannerItem {
    title: string
    text: string
    buttonText: string
    buttonHref: string
}

export const indexBannerTry: IndexBannerItem = {
    title: 'Попробуйте бесплатно!',
    text: 'Бесплатная консультация – получите рекомендации по выбору самого выгодного тарифа!',
    buttonText: 'Попробовать',
    buttonHref: ''
}

export const indexBannerOnline: IndexBannerItem = {
    title: 'Мы всегда на связи!',
    text: 'Бесплатная консультация – получите рекомендации по выбору самого выгодного тарифа!',
    buttonText: 'Перейти в Телеграм',
    buttonHref: ''
}

export const indexBannerFree: IndexBannerItem = {
    title: 'Попробуйте бесплатно!',
    text: 'Бесплатная консультация – получите рекомендации по выбору самого выгодного тарифа!',
    buttonText: 'Попробовать',
    buttonHref: ''
}
